/* eslint-disable */
import React, { useState } from "react";
import Select from "react-select";
import { useHistory } from 'react-router-dom';
import "./HireToRetire.css";
import styles from "./HireToRetire.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import InfoCards from "../../components/TransitionPageComp/InfoCards/InfoCards";
import DashboardSection from "../../components/DashboardContainer/DashboardSection";
import PercentageIndicator from "../../atomicComponents/PercentageIndicator/PercentageIndicator";
import DetailedDomainTile from "../../atomicComponents/DetailedDomainTile/DetailedDomainTile";

function HireToRetireMainComp() {
  const history = useHistory();

  const entityOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "tmcv", label: "TMCV" },
    { value: "tmpv", label: "TMPV" },
    { value: "jlr", label: "JLR" },
    { value: "agratas", label: "Agratas" },
  ];

  //   const geographyOptions = [
  //     { value: 'undefined', label: 'Select' },
  //     { value: 'All', label: '-All-' },
  //     { value: 'domastic', label: 'Domastic' },
  //     { value: 'international', label: 'International' },
  //   ];

  const yearOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
  ];

  const quarterOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "Q1", label: "Q1" },
    { value: "Q2", label: "Q2" },
    { value: "Q3", label: "Q3" },
    { value: "Q4", label: "Q4" },
  ];

  const monthOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "Jan", label: "Jan" },
    { value: "Feb", label: "Feb" },
    { value: "Mar", label: "Mar" },
    { value: "Apr", label: "Apr" },
    { value: "May", label: "May" },
    { value: "Jun", label: "Jun" },
    { value: "Jul", label: "Jul" },
    { value: "Aug", label: "Aug" },
    { value: "Sep", label: "Sep" },
    { value: "Oct", label: "Oct" },
    { value: "Nov", label: "Nov" },
    { value: "Dec", label: "Dec" },
  ];

  const [entity, setEntity] = useState(yearOptions[0]);
  const [geography, setgeography] = useState(yearOptions[0]);
  const [year, setYear] = useState(yearOptions[0]);
  const [quarter, setQuarter] = useState(quarterOptions[0]);
  const [month, setMonth] = useState(monthOptions[0]);

  const handleApply = () => {
    console.log("Apply clicked with:", {
      year: year.value,
      quarter: quarter.value,
      month: month.value,
    });

    if(entity.value == 'jlr')
    {
      history.push("/Procure-To-Pay/JLR-Main");
    }
    else if(entity.value == 'agratas'){
      history.push("/Procure-To-Pay/Agratas-Main");
    }
    else{
      history.push("/Procure-To-Pay");
    }
  };

  const handleReset = () => {
    setEntity(entity[0]);
    setgeography(geography[0]);
    setYear(yearOptions[0]);
    setQuarter(quarterOptions[0]);
    setMonth(monthOptions[0]);
  };

  const stats = [
    { title: "Paid On Time", value: 98.21 },
    { title: "PO Penetration", value: 99.17 },
    { title: "PO Creation Volume", value: 7820 },
    { title: "MSME Vendor Enrolled", value: 523 },
    { title: "Invoice Verified (Automatic)", value: 525897 },
    { title: "Invoice Verified (Manual)", value: 26347 },
  ];

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={setEntity}
                options={entityOptions}
                isSearchable={false}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
        <label className={styles.filter_label}>Geography</label>
        <div className={styles.filter_select_wrapper}>
          <Select
            value={geography}
            onChange={setgeography}
            options={geographyOptions}
            isSearchable={false}
          />
        </div>
      </div> */}
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={setYear}
                options={yearOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={setQuarter}
                options={quarterOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={setMonth}
                options={monthOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6 mb-4">
        <div>
        <DetailedDomainTile
              title="Talent Operation"
              showButton={false}
              path="/Order-To-Cash/Sales"
            />
        </div>
        <div className="mb-3">
          <DashboardSection
            title="Payroll and Compliance"
            disableDetailView={false}
            detailPath="/Hire-To-Retire/Payroll-Compliance"
          >
            <div className="dashboard1">
              {/* Empty cell for corner */}
              <div className="corner"></div>

              {/* Column Headers */}
              <div className="header1">Timeliness</div>
              <div className="header1">Accuracy</div>

              {/* Row Labels */}
              <div className="row-label1">Payroll</div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={0} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={"NA"} activeIndex={-1} />
              </div>
            </div>
          </DashboardSection>
          </div>
          <div>
          <DashboardSection
            title="Time Office Administration, Retirals"
            disableDetailView={false}
            detailPath="/Hire-To-Retire/Time-Office-Retrials"
          >
            <div className="dashboard1">
              {/* Empty cell for corner */}
              <div className="corner"></div>

              {/* Column Headers */}
              <div className="header1">Timeliness</div>
              <div className="header1">Accuracy</div>

              {/* Row Labels */}
              <div className="row-label1">Time Office Admin</div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={0} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={1} />
              </div>

            {/* Row Labels */}
              <div className="row-label1">Retirals</div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={0} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={"NA"} activeIndex={-1} />
              </div>
            </div>
          </DashboardSection>
          </div>
        </div>
        <div className="col-lg-6 mb-4">
        <div>
        <DetailedDomainTile
              title="Talent Services"
              showButton={false}
              path="/Order-To-Cash/Sales"
            />
        </div>
        <div className="mb-3">
          <DashboardSection
            title="Benefits Administration"
            disableDetailView={false}
            detailPath="/Hire-To-Retire/Benefit-Administration"
          >
            <div className="dashboard1">
              {/* Empty cell for corner */}
              <div className="corner"></div>

              {/* Column Headers */}
              <div className="header1">Timeliness</div>
              <div className="header1">Accuracy</div>

              {/* Row Labels */}
              <div className="row-label1">Benefits Admin</div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={0} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={1} />
              </div>
            </div>
          </DashboardSection>
          </div>
          <div>
          <DashboardSection
            title="Recuritment, Employee Master Data Management, L&D, PMS MIS"
            disableDetailView={false}
            detailPath="/Hire-To-Retire/Recuritment"
          >
            <div className="dashboard1">
              {/* Empty cell for corner */}
              <div className="corner"></div>

              {/* Column Headers */}
              <div className="header1">Timeliness</div>
              <div className="header1">Accuracy</div>

              {/* Row Labels */}
              <div className="row-label1">Recuritment</div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={0} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={1} />
              </div>

            {/* Row Labels */}
              <div className="row-label1">Employee MDM</div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={0} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={1} />
              </div>

            
            {/* Row Labels */}
            <div className="row-label1">L&D PMS MIS</div>
              <div className="cell1">
                <PercentageIndicator percentage={"NA"} activeIndex={-1} />
              </div>
              <div className="cell1">
                <PercentageIndicator percentage={99} activeIndex={1} />
              </div>
            </div>
          </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
}

export default HireToRetireMainComp;
